import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=225986d6"
import script from "./RadioGroup.vue?vue&type=script&lang=js"
export * from "./RadioGroup.vue?vue&type=script&lang=js"
import style0 from "./RadioGroup.vue?vue&type=style&index=0&id=225986d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports